import { development, prod, local} from './env';

export default (() => {
  switch (process.env.REACT_APP_ENV) {
    case 'dev':
      return development;
    case 'prod':
      return prod;
    case 'local':
      return local;

    default:
      return development;
  }
})()